import "./App.scss";
import React, { useEffect, useState } from "react";
import RouterApp from "./router/Router";
import axios from "axios";
import { URL } from "./constants/url";
import Loading from "./components/loading/Loading";

function App() {
  const [priceData, setPriceData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [billData, setBillData] = useState([]);
  const [priceOfTime, setpriceOfTime] = useState([]);
  const [user, setUser] = useState([]);

  useEffect(() => {
    // Fetch data when component mounts
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const priceResponse = await axios.get(`${URL}/api/prices`);
      const productResponse = await axios.get(`${URL}/api/products`);
      const billResponse = await axios.get(`${URL}/api/bills`);
      const timeResponse = await axios.get(`${URL}/api/prices`);
      const userResponse = await axios.get(`${URL}/api/admin/users`);

      setPriceData(priceResponse.data);
      setProductData(productResponse.data);
      setBillData(billResponse.data);
      setpriceOfTime(timeResponse.data);
      setUser(userResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  return (
    <div className="App">
      {productData.length === 0 || billData.length === 0 ? (
        <div className="parent-container">
          <div className="frame-loading">
            <Loading />
          </div>
        </div>
      ) : (
        <>
          <AppContext.Provider
            value={{
              priceData,
              setPriceData,
              productData,
              setProductData,
              billData,
              setBillData,
              priceOfTime,
              setpriceOfTime,
              user,
            }}
          >
            <RouterApp />
          </AppContext.Provider>
        </>
      )}
    </div>
  );
}

export const AppContext = React.createContext();

export default App;
